import { SystemUser } from './system-user';
import { Currency } from './currency';
import Decimal from 'decimal.js';
import { BookingIdListItem } from './booking-id-list-item';

export class RefundRequest {

    constructor(
        public bookingIds: BookingIdListItem[],
        public requestedBy: SystemUser,
        public amount: Decimal,
        public currency: Currency,
        public iban: string,
        public isPaid: boolean,
        public approvedBy: SystemUser,
        public reason: string,
        public bic: string,
        public isApproved: boolean,
        public accountHolderName: string,
        public studentName: string,
        public created?: Date,
        public createdBy?: SystemUser,
        public lastModifiedBy?: SystemUser,
        public lastModified?: Date,
        public id?: number,
        public paidBy?: SystemUser
    ){}
}
